import styled from 'styled-components';

export const Container = styled.div``;

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 18px;
  margin-bottom: 10px;
`;

export const Cancel = styled.button`
  color: #474d66;
  font-weight: 500;
  font-size: 14px;
  background: none;
  border: none;
  outline: 0;
`;

export const Done = styled.button`
  color: ${({ disabled }) => (disabled ? '#C1C4D6' : '#1371FE')};
  font-weight: 500;
  font-size: 14px;
  margin-left: 40px;
  margin-right: 16px;
  background: none;
  border: none;
  outline: 0;
`;
